// extracted by css-extract-rspack-plugin
export default {"container":"_c4dee29a"};